var _ = require('underscore');
var UseModalBehavior = require('./../widget/modal/UseModalBehavior');

var appointmentConfigurationModel = require('./../appointment-config/appointmentConfigurationModel.js');
var MultiAppointmentSelectionModalView = require('./MultiAppointmentSelectionModalView');

/**
 * This behavior adds a modal to the view that will display when an element is clicked to allow the user to choose whether
 * to checkin/register one or multiple appointments for the same day.
 *
 * @class MultiAppointmentSelectionBehavior
 * @constructor
 */
module.exports = UseModalBehavior.extend({

  events: _.extend({}, UseModalBehavior.prototype.events, {
    'click [data-appointment-register]': '_registerAppointment'
  }),

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    this.listenTo(appointmentConfigurationModel, 'load-complete', this.render);
    appointmentConfigurationModel.loadOnce();
    this.listenTo(appointmentConfigurationModel, 'change:allowMultipleAppointmentsRegistration', this.render);
  },

  mixin: _.extend({}, UseModalBehavior.prototype.mixin, {
    /**
     * Get the patient's vecna id from the view.
     * Defined as a mixin so that the view can override the logic.
     * Default logic is to use the view._patientVecnaId property.
     *
     * @method _getPatientVecnaId
     * @return {String} the patient's vecna id.
     * @private
     */
    _getPatientVecnaId: function() {
      return this.view._patientVecnaId;
    },

    /**
     * Get the appointment's external id from the view.
     * Defined as a mixin so that the view can override the logic.
     * Default logic is to use the view._appointmentExternalId property.
     *
     * @method _getAppointmentExternalId
     * @return {String} the appointment's external id.
     * @private
     */
    _getAppointmentExternalId: function() {
      return this.view._appointmentExternalId;
    },

    /**
     * Get the whether the user is a staff user from the view.
     * Defined as a mixin so that the view can override the logic.
     * Default logic is to use the view._userIsStaff property.
     *
     * @method _getUserIsStaff
     * @return {Boolean} whether the user is a staff user from the view.
     * @private
     */
    _getUserIsStaff: function() {
      return this.view._userIsStaff;
    },

    /**
     * Get the date of the appointment as a Moment from the view.
     * Defined as a mixin so that the view can override the logic.
     * Default logic is to return null.
     *
     * @method _getAppointmentDate
     * @return {Moment} a moment representation of the appointment's date.
     * @private
     */
    _getAppointmentDate: function() {
      return null;
    }
  }),

  /**
   * Conditionally show the modal if multi-appointments is enabled.
   * @return {Boolean}
   * @private
   */
  _registerAppointment: function() {
    if (!this._isMultiAppointment()) {
      return true;
    }

    var multipleAppointmentModal = this._getOrCreateMultipleAppointmentModal();

    this.view.showModal(multipleAppointmentModal);
    // Returning false from an event handler will automatically call event.stopPropagation() and event.preventDefault().
    return false;
  },

  /**
   * @method _isMultiAppointment
   * @return {Boolean} true if multi-appointment is configured on.  False otherwise.
   * @private
   */
  _isMultiAppointment: function() {
    if (appointmentConfigurationModel.isLoading() || !appointmentConfigurationModel.hasLoadedOnce()) {
      return false;
    }
    return appointmentConfigurationModel.get('allowMultipleAppointmentsRegistration');
  },

  /**
   * Lazy-create the modal view for selecting whether to multi-prereg or not.
   * If the modal view hasn't been created, then create it.  Either way return a created modal view.
   * @method _getOrCreateMultipleAppointmentModal
   * @return {ModalDialogWidget}
   */
  _getOrCreateMultipleAppointmentModal: function() {
    if (!this._multipleAppointmentModal) {
      this._multipleAppointmentModal = new MultiAppointmentSelectionModalView({
        patientVecnaId: this.view._getPatientVecnaId(),
        appointmentExternalId: this.view._getAppointmentExternalId(),
        regDateMoment: this.view._getAppointmentDate(),
        userIsStaff: this.view._getUserIsStaff()
      });
    }
    return this._multipleAppointmentModal;
  }
});
